import { Inject, Injectable, DOCUMENT } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class ThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  private get documentClass(): DOMTokenList {
    return this.document.documentElement.classList;
  }

  public toggleUiTheme(): void {
    this.documentClass.contains('dark')
      ? this.documentClass.remove('dark')
      : this.documentClass.add('dark');
  }

  public darkThemeActivated(): boolean {
    return this.documentClass.contains('dark');
  }

  public loadTheme(themeName: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    const themeSrc = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;

    if (themeSrc) {
      themeSrc.href = `${themeName}.css`;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${themeName}.css`;

      head.appendChild(style);
    }
  }
}
